import { Component } from "react";
import { AlertTriangle, RefreshCw, ArrowLeft } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || "Errore imprevisto" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI ErrorBoundary:", error, info);
  }

  componentDidUpdate(prevProps) {
    // Reset automatico quando si cambia pagina/route
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, message: "" });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="app-error-boundary">
        <div className="max-w-lg w-full rounded-xl border border-warning/40 bg-warning/5 p-6">
          <div className="flex items-start gap-3">
            <AlertTriangle className="h-6 w-6 text-warning shrink-0 mt-0.5" />
            <div className="flex-1">
              <h1 className="font-heading font-bold text-lg text-foreground">Qualcosa è andato storto in questa schermata</h1>
              <p className="text-sm text-muted-foreground mt-2">
                Si è verificato un errore imprevisto durante il caricamento. Capita a volte aprendo il
                <b className="text-foreground"> Preventivo </b>quando il layout del tetto non è ancora stato confermato.
              </p>
              <div className="mt-4 rounded-lg border border-border bg-background/60 p-3">
                <div className="text-xs uppercase tracking-widest text-muted-foreground mb-2">Cosa fare</div>
                <ul className="text-sm text-foreground space-y-1.5 list-disc pl-5">
                  <li><b>Ricarica la pagina</b> con il pulsante qui sotto.</li>
                  <li>Se stavi aprendo il <b>Preventivo</b> da una <b>Consulenza</b>, torna nella scheda Consulenza e conferma il layout del tetto con <b>«Usa il layout»</b> prima di procedere.</li>
                  <li>Se il problema si ripete, segnala all'assistenza il messaggio tecnico qui sotto.</li>
                </ul>
              </div>
              {this.state.message && (
                <details className="mt-3" data-testid="app-error-details">
                  <summary className="text-xs text-muted-foreground cursor-pointer">Dettaglio tecnico</summary>
                  <pre className="mt-2 text-[11px] text-muted-foreground whitespace-pre-wrap break-words bg-secondary/30 rounded p-2">{this.state.message}</pre>
                </details>
              )}
              <div className="flex flex-wrap gap-2 mt-5">
                <button onClick={() => window.location.reload()}
                  className="inline-flex items-center gap-2 rounded-lg bg-primary text-primary-foreground font-semibold px-4 py-2 text-sm hover:opacity-90 transition-opacity"
                  data-testid="app-error-reload"><RefreshCw className="h-4 w-4" /> Ricarica la pagina</button>
                <button onClick={() => window.history.back()}
                  className="inline-flex items-center gap-2 rounded-lg border border-border text-foreground font-medium px-4 py-2 text-sm hover:bg-secondary/40 transition-colors"
                  data-testid="app-error-back"><ArrowLeft className="h-4 w-4" /> Torna indietro</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
